
import React from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import { withParams } from '../helpers';
import API from '../APIClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DeleteConfirmButton from './components/DeleteConfirmButton';

const APIClient = new API();

interface Props { params:any; }
interface State { magazines?: Array<any> }

class InfoItems extends React.Component <Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {}

    this.getData = this.getData.bind(this)
    this.delete = this.delete.bind(this)
  }


  componentDidMount() {
    this.getData();
  }

  getData(){

    APIClient.info().then((data) => {
      console.log(data)
      this.setState({ magazines:data })
    }).catch((e) => {
      
      window.location.href = "./login/2"
    })
  }

  delete(id?:number){
    if(window.confirm("Weet u het zeker?")){ 
      APIClient.deleteInfo(id as number).then(() => {
        this.getData(); 
      }) 
    }
  }

  render() {
    if(!this.state.magazines) {
      return <></>
    }


    let rows:Array<any> = []
    this.state.magazines.forEach((infoItem,index) => { 
      rows.push(<tr key={index}>
        <td>{infoItem.id}</td>
        <td><a href={`${APIClient.website}/info-oost/${infoItem.id}`}>{infoItem.title}</a></td> 
        <td> 
          <a href={`${APIClient.path}/info-oost/${infoItem.id}`}>
          <Button variant="warning" size="sm"> <FontAwesomeIcon icon="pen-clip" /> </Button></a>&nbsp;
          <DeleteConfirmButton callback={() => { this.delete(infoItem.id) }} />
        </td>
      </tr>)
    })
    

    return  <Card>
        <Card.Header><FontAwesomeIcon icon="file-pdf" /> &nbsp;Info-oost overzicht
          <a href="/info-oost/toevoegen"><Button variant="success" size="sm" style={{float:"right"}}><FontAwesomeIcon icon="plus" /> Toevoegen </Button></a>
        </Card.Header>
        <Card.Body>
          <Table striped>
            <thead>
              <tr>
                <th style={{width:"40px"}}>#</th>
                <th>Titel</th>
                <th style={{width:"200px"}}>Acties</th>
              </tr>
            </thead>
            <tbody><>
              { (rows && rows.length) && rows }
              { (!rows || !rows.length) && <>Geen data</> }
            </>
            </tbody>
          </Table>
        </Card.Body>
    </Card>
  }
}



export default withParams(InfoItems)